<template>
	<nk-page commercialAccess="System" :policyClaims="`Accounting_${(settings.docGroup === GROUP_OPENING ? 'Opening_Document' : 'Document_Management')}`" :additionalInfoObj="additionalInfoObj" :buttons="footerPageButtons()" body-class="d-flex flex-column" :displayModeTogglerOptions="{ top: 0, left: '45px', stateKey: 'documentSingleDisplayMode' }">
		<template #default="{ displayMode, isRightMode }">
			<!-- <template #badges>
			<nk-badge system="accounting">
			<nk-badge-item type="system" modelValue="accounting"></nk-badge-item>
			<nk-badge-item type="system" modelValue="accounting" :title="settings.docGroup === GROUP_OPENING ? $t(`forms.Opening_Document`) : $t(`forms.Document`)"></nk-badge-item>
			<nk-badge-item type="edition" :modelValue="retreiveIsEmpty() ? 'new' : 'edit'"></nk-badge-item>
			</nk-badge>
		</template> -->
			<div class="overflow-auto h-100 d-flex form-container" :class="{ 'flex-column': !isRightMode }">
				<div class="doc-header nk-card position-relative" :style="isRightMode ? { flex: '0 0 calc(16.666% - 0.25rem)', marginLeft: '1rem' } : {}" :class="isRightMode ? '' : 'w-100 mb-3'">
					<div class="doc-top-bar doc-header-layer">
						<div class="doc-top-bar__content">
							<span v-if="docHeaderIsLocked" class="doc-header-pill doc-header-pill--lock" :title="$t('document.m.doc-mode-is-lock')">
								<i class="fa-solid fa-lock"></i>
								<span>{{ $t('document.preview-state') }}</span>
							</span>
							<span v-if="docHeaderIsNew" class="doc-header-pill doc-header-pill--new">{{ $t('badges.edition.new') }}</span>
							<span v-if="!docHeaderIsNew && docHeaderShowRegisteredBadge" class="doc-header-pill doc-header-pill--status" :style="docHeaderRegisteredBadgeStyle">
								<i :class="docHeaderRegisteredConfig.icon"></i>
								<span>{{ document.type.name }}</span>
							</span>
							<span v-else-if="docHeaderShowStatus" class="doc-header-pill doc-header-pill--status" :style="docHeaderStatusBadgeStyle">
								<i :class="docHeaderStateConfig.icon"></i>
								<span>{{ docHeaderInfo.status }}</span>
							</span>
							<span v-if="docHeaderShowSource" class="doc-header-pill doc-header-pill--source">{{ docHeaderInfo.source }}</span>
						</div>
					</div>
					<div class="row no-gutters doc-header-layer">
						<div class="col">
							<form class="doc-form" id="document-header">
								<div class="row no-gutters">
									<div class="col-12 p-0" :class="{ ' col-sm-4': !isRightMode }">
										<nk-col-form-group class="item-form-group" :label="$t('document.f.document-code') + ':'" :labelSizes="{ sm: (isRightMode) ? 12 : 6 }" :dataSizes="{ sm: (isRightMode) ? 12 : 6 }" :labelAligns="{ sm: (isRightMode) ? 'right' : 'left', md: (isRightMode) ? 'right' : 'left', lg: (isRightMode) ? 'right' : 'left' }">
											<!-- if its preview mode code should be disabled -->
											<nk-input ref="docCode" v-model="document.code" @searchClick="allDocuments" @blur="docCodeBlur" :options="settings.docCode" :tabindex="101" startup :disabled="([FORM_MODES.READONLY].includes(settings.mode) && grandParentType() === 'modal' || settings.docGroup === GROUP_OPENING) ? true : null"></nk-input>
										</nk-col-form-group>
									</div>
									<div class="col-12 p-0" :class="{ ' col-sm-4': !isRightMode }">
										<nk-col-form-group :label="$t('document.f.attachNumber') + ':'" :labelSizes="{ sm: (isRightMode) ? 12 : 6 }" :dataSizes="{ sm: (isRightMode) ? 12 : 6 }" :labelAligns="{ sm: (isRightMode) ? 'right' : 'left', md: (isRightMode) ? 'right' : 'left', lg: (isRightMode) ? 'right' : 'left' }">
											<nk-label ref="docAttachNumber" :modelValue="document.attachNumber" style="text-align:right;" readonly class="form-control form-control-sm" :value="document.attachNumber">
												&nbsp;
											</nk-label>
										</nk-col-form-group>
									</div>
									<div class="col-12 p-0" :class="{ ' col-sm-4': !isRightMode }">
										<nk-col-form-group :label="$t('document.f.date') + ':'" :labelSizes="{ sm: (isRightMode) ? 12 : 6 }" :dataSizes="{ sm: (isRightMode) ? 12 : 6 }" :labelAligns="{ sm: (isRightMode) ? 'right' : 'left', md: (isRightMode) ? 'right' : 'left', lg: (isRightMode) ? 'right' : 'left' }">
											<nk-date ref="docDate" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null" :options="settings.date" v-model="document.date" :tabindex="102" v-on:defaultValue="emitedDefaultDate"></nk-date>
										</nk-col-form-group>
									</div>
								</div>
								<div class="row no-gutters">
									<div class="col-12 p-0" :class="{ ' col-md-12': !isRightMode }">
										<nk-col-form-group :label="$t('document.f.description') + ':'" :labelSizes="{ sm: (isRightMode) ? 12 : 2 }" :dataSizes="{ sm: (isRightMode) ? 12 : 10 }" :labelAligns="{ sm: (isRightMode) ? 'right' : 'left', md: (isRightMode) ? 'right' : 'left', lg: (isRightMode) ? 'right' : 'left' }" :disabled="document.code === 0 ? true : null">
											<nk-descriptions-input ref="docDescription" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null" v-model="document.description" :options="{ entityType: 'Form', entityId: this.findSystemForm('Document').id, entityTitle: this.$t('document.title') }" :tabindex="104" />
										</nk-col-form-group>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
				<div class="nk-card doc-details-container d-flex flex-column flex-grow-2 p-0" :style="isRightMode ? { flex: '1 1 calc(83.333% - 0.25rem)' } : {}" :class="isRightMode ? '' : 'w-100'" style=" padding: 1px 10px !important; ">
					<div class="doc-details" style="min-height:300px">
						<!-- <nk-table v-model="selectDetailRow" :data="document.details" :options="tableOptionsComputed" tabindex="200" v-if="tableToggler" ref="table"></nk-table> -->
						<NkGrid v-model="selectDetailRow" @update:modelValue="selectedDetailRowChanged" :data="document.details" :columns="settings.gridOptions.columns" :options="settings.gridOptions.options" ref="table" :tabIndex="200" :actions="settings.gridOptions.actions" :buttons="settings.gridOptions.buttons" @data-changed="(params) => updateDocumentAggregation(params)" @row-data-updated="(params) => updateDocumentAggregation(params)" @cell-focused="(params) => cellFocusChanged(params)" />
					</div>
					<div class="d-flex align-items-center">
						<div class="col-6 col-md-7 col-sm-8">
							<div v-if="tableFocusedCell?.includes('center') && selectedFloatingCenterInfo" class="float-right p-2">
								<div class="d-inline text-muted">
									<a href="#" v-for="(p, index) in selectedFloatingCenterInfo.parents.sort((a, b) => a.level - b.level)" :key="index" @click="showTurnOver(p, p.level, [], true)">
										{{ p.name }}
										<span v-if="index + 1 == selectedFloatingCenterInfo.parents.length"> (&#x200E;{{ p.accountingCode.toLocaleDigits() }}) </span>
										<span v-if="index + 1 < selectedFloatingCenterInfo.parents.length" class="text-muted"> > </span>
									</a>
								</div>
								<span class="font-weight-bold">مانده: </span>
								<nk-label :modelValue="selectedFloatingCenterInfo.balance" :options="{ type: 'balance' }" class="account-form-Balance font-weight-bold"></nk-label>
							</div>
							<div v-else-if="selectedAccountInfo" class="float-right p-2">
								<div class="d-inline text-muted">
									<a href="#" v-for="(p, index) in selectedAccountInfo.parents" :key="index" @click="showTurnOver(p, p.level)">
										{{ p.name }}
										<span v-if="index + 1 == selectedAccountInfo.parents.length"> (&#x200E;{{ p.accountingCode.toLocaleDigits() }}) </span>
										<span v-if="index + 1 < selectedAccountInfo.parents.length" class="text-muted"> > </span>
									</a>
								</div>
								<span class="font-weight-bold">مانده: </span>
								<nk-label :modelValue="accountBalance" :options="{ type: typeof accountBalance === 'string' ? 'string' : 'balance', nature: selectedAccountInfo.accountNature }" class="account-form-Balance font-weight-bold"></nk-label>
							</div>
						</div>
						<div class="col-6 col-md-5 col-sm-4">
							<div class="sum-card w-100 d-flex">
								<div class="sum-section">
									<span class="sum-title">{{ $t('document.f.debit') }}:</span>
									<span class="sum-value debit">{{ monify(documentAggregation.debit) }}</span>
								</div>
								<div class="sum-section">
									<span class="sum-title">{{ $t('document.f.credit') }}:</span>
									<span class="sum-value credit">{{ monify(documentAggregation.credit) }}</span>
								</div>
								<div class="sum-section total-section">
									<span class="sum-title">{{ $t('document.f.difference') }}:</span>
									<span class="sum-value" :class="{ 'debit': documentAggregation.debit > documentAggregation.credit, 'credit': documentAggregation.credit > documentAggregation.debit }">{{ monify(Math.abs(documentAggregation.credit - documentAggregation.debit)) }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
	</nk-page>
</template>
<script>
	import _ from 'lodash'
	import { mapGetters, mapActions } from 'vuex'
	import { post } from '~/plugins/nikan-api'
	import Input from '~/components/general/nikan-input.vue'
	import NikanDate from '~/components/general/nikan-date.vue'
	import DropdownAccount from '~/components/form/dropdown/dropdown-account.vue'
	import DocsList from './document-selector'
	import validators, { VCustom, isEmpty, Checker, VRequiredIfValue } from '~/statics/validators.js'
	import $sc from '~/plugins/shortcut.collection.js'
	import dialog from '~/plugins/nikan-dialog-plugin'
	import { toFloat } from '~/plugins/force-to-number'
	import { helpers } from '@nikan/text-visualizer'
	import Endpoints from '@nikan/endpoints'
	import MultiCurrencyCellView from '~/components/form/multi-currency/multi-currency-cell-view'
	import MultiCurrencyCell from '~/components/form/multi-currency/multi-currency-cell'
	import DropDownCenter from '~/components/form/dropdown/dropdown-floating-center'
	import emptyId from '~/statics/empty-id'
	import FrequentDescriptionsInput from '~/components/form/frequent-descriptions/frequent-descriptions-input.vue'
	import NoteManger from "../../components/note/note-manager"
	import { defineAsyncComponent } from 'vue'
	import { PrintDataConvertTypes } from '~/plugins/stimul'
	// import TurnOver from '~/views/reports/turn-over'
	// import AccessControl from '~/views/operation-roles/access-control'
	// import AttachmentManager from '~/components/uploader/attachment-manager'
	// import CopyFromDocument from '~/views/documents/copy-from-document'
	// import ChangeLog from '~/components/form/change-log/change-log.vue'
	// import DocumentSettings from '~/views/settings/settings-document'
	// import PreviewContainer from '~/components/form/preview-container'
	import PreviewContainer from '~/components/form/preview-container'
	import { getEntityNotes, idCheckChanged } from '@/plugins/helper'
	import NkGrid from '~/components/ag-grid/new-ag-grid'
	import SumBy from 'lodash/sumBy'
	import isEqual from 'lodash/isEqual'
	import { tableFields } from '@/components/ag-grid/interfaces'
	import { getAttachmentsCount } from '@/plugins/uploader'

	const TYPE_SAVED = { id: 'saved' }

	const GROUP_OPENING = 'Opening_Account'

	export default {
		name: 'document-issue',
		modal: {
			helpTag: 'DocumentSingle'
		},
		// components: {
		// 	TurnOver: defineAsyncComponent(() => import('~/views/reports/turn-over')),
		// 	AccessControl: defineAsyncComponent(() => import('~/views/operation-roles/access-control')),
		// 	AttachmentManager: defineAsyncComponent(() => import('~/components/uploader/attachment-manager')),
		// 	CopyFromDocument: defineAsyncComponent(() => import('~/views/documents/copy-from-document')),
		// 	ChangeLog: defineAsyncComponent(() => import('~/components/form/change-log/change-log.vue')),
		// 	DocumentSettings: defineAsyncComponent(() => import('~/views/settings/settings-document')),
		// 	PreviewContainer: defineAsyncComponent(() => import('~/components/form/preview-container')),
		// },
		props: {
			data: { type: Object },
			options: { type: Object },
		},
		components: {
			NkGrid
		},
		data() {
			return {
				GROUP_OPENING: GROUP_OPENING,
				onCodeEnterPressed: false,
				min_centers_cols: 2,
				tableToggler: false,
				tableFocusedCell: null,
				selectedFloatingCenterInfo: null,
				documentAggregation: {
					credit: 0,
					debit: 0,
				},
				originalDocument: {
					id: '',
					code: '',
					date: null,
					description: null,
					details: null,
					isNew: true,
				},
				enteringRow: null,
				settings: {
					hideFooterButtons: false,
					extendedColumnsEnabled: true,
					docCode: {
						searchable: true,
						required: true,
						mode: 'strnumber',
						onSearchClick: this.allDocuments,
					},
					type: {
						searchable: true,
						required: true,
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						display: function (item) {
							return item.name
						},
						searchableFields: ['name'],
					},
					date: {
						pickerEnabled: true,
						defaultValue: 'now',
						pickerCss: 'btn btn-default',
					},
					gridOptions: {
						buttons: {
							addBtn: {
								options: {
									visible: true
								}
							},
							duplicateBtn: {
								options: {
									visible: true,
								}
							},
							upBtn: {
								options: {
									visible: true
								}
							},
							downBtn: {
								options: {
									visible: true
								}
							},
							deleteBtn: {
								options: {
									visible: true
								}
							},
						},
						actions: [
							{
								name: this.$t('duplicate-from-above'),
								shortcut: $sc.find('copy-value', 'document'),
								handler: function (row, index, data, col, api) {
									// var inColumn = col != null && ['currencyValues'].findIndex((val) => val === col.colDef.field) > -1

									if (index > 0) {
										const editingCell = api.getEditingCells()[0]

										api.stopEditing()

										var prevRow = data[index - 1]

										row[col.colDef.field] = _.cloneDeep(prevRow[col.colDef.field])

										if (col.colDef.field === 'currencyValues') {
											row[col.colDef.field] = row.currencyValues.map(x => {
												x.id = emptyId

												return x
											})
										}

										row.rowState = row.rowState === 'unchanged' ? 'changed' : row.rowState

										api.applyTransaction({ update: [row] })

										if (editingCell)
											api.startEditingCell({
												rowIndex: editingCell.rowIndex,
												colKey: editingCell.column.getId()
											})
										return true
									}
								},
							},
							{
								name: this.$t('balance-document'),
								shortcut: $sc.find('balance-table', 'document'),
								handler: (row, index, data, col, api) => {
									if (index < 0 || row.rowState === 'deleted') return

									const editingCell = api.getEditingCells()[0]

									api.stopEditing()
									let sumOtherRowsDebit = _.sumBy(data.filter((item, i) => item[tableFields.id] !== row[tableFields.id] && item.rowState !== 'deleted'), function (o) { return toFloat(o.currencyValues[0]?.debit) })
									let sumOtherRowsCredit = _.sumBy(data.filter((item, i) => item[tableFields.id] !== row[tableFields.id] && item.rowState !== 'deleted'), function (o) { return toFloat(o.currencyValues[0]?.credit) })
									row.currencyValues[0].debit = sumOtherRowsCredit > sumOtherRowsDebit ? Math.abs(sumOtherRowsCredit - sumOtherRowsDebit) : 0
									row.currencyValues[0].credit = sumOtherRowsCredit < sumOtherRowsDebit ? Math.abs(sumOtherRowsCredit - sumOtherRowsDebit) : 0

									row.rowState = row.rowState === 'unchanged' ? 'changed' : row.rowState

									api.applyTransaction({ update: [row] })

									if (editingCell)
										api.startEditingCell({
											rowIndex: editingCell.rowIndex,
											colKey: editingCell.column.getId()
										})

									return true
								},
							},
						],
						options: {
							gridId: 'document-details',
							rowHeight: 26,
							prepareNewRow: (prevRow) => {
								const row = { description: prevRow?.description || '' }
								return this.generateEmptyRow(row)
							},
							rowIsLocked: (row) => {
								return (row.isReadOnly != null && row.createdByType === true) || row.fromOtherModule === true
							},
							suppressHeaderMenuButton: true,
							suppressHeaderContextMenu: true,
							defaultColDef: {
								floatingFilter: true,
								cellStyle: {
									fontSize: '12px'
								}
							},
							isEditable: true,
							onCopyRow: (row) => {
								row.id = emptyId

								if (row.currencyValues)
									row.currencyValues = row.currencyValues.map(x => {
										x.id = emptyId

										return x
									})

								return row
							},
							prepareDataOnMount: false
						},
						columns: [
							{
								field: 'rowNumber',
								headerName: '...',
								width: 60,
								type: 'rowNumber'
							},
							{
								field: 'account',
								type: 'account',
								headerName: this.$t('document.f.account'),
								validators: validators('required'),
								width: 150,
								isEditable: true,
								valueSetter: (params) => {
									const row = params.data

									if (params.newValue?.id === params.oldValue?.id)
										return false

									row.account = params.newValue

									for (var f in row) {
										if (f.indexOf('center') > -1 && f !== 'centers')
											row[f] = null

										if (f === 'centers')
											row[f] = []
									}

									return true
								}
							},
							{
								field: 'center1',
								type: 'center',
								headerName: this.$t('document.center') + ' 1'.toLocaleDigits(),
								isEditable: true,
								validators: validators(new VRequiredIfValue('account', (val) => {
									if (val)
										return (val?.maxCenterLevel || 0) >= 1
									return false
								})),
								cellEditorParams: {
									options: (params) => {
										return {
											rowIdentifier: 'id',
											searchable: true,
											required: true,
											remoteSearch: false,
											placeholder: this.$t('search-it'),
											display: (item) => `${item.accountingCode} - ${item.name}`,
											searchableFields: ['name', 'accountingCode'],
											baseAccountId: params.node.data.account != null ? params.node.data.account.id : 0,
											editable: true,
											centerLevel: 1,
											selectorWidth: 400,
											locateSelectorBasedOnDocument: true,
											showSelectedBalance: false
										}
									}
								},
								entering: (row) => {
									return row.account != null
								},
							},
							{
								field: 'center2',
								type: 'center',
								headerName: this.$t('document.center') + ' 2'.toLocaleDigits(),
								isEditable: true,
								validators: validators(new VRequiredIfValue('account', (val) => {
									if (val)
										return (val?.maxCenterLevel || 0) >= 2
									return false
								})),
								cellEditorParams: {
									options: (params) => {
										return {
											rowIdentifier: 'id',
											searchable: true,
											required: true,
											remoteSearch: false,
											placeholder: this.$t('search-it'),
											display: (item) => `${item.accountingCode} - ${item.name}`,
											searchableFields: ['name', 'accountingCode'],
											baseAccountId: params.node.data.account != null ? params.node.data.account.id : 0,
											editable: true,
											centerLevel: 2,
											selectorWidth: 400,
											locateSelectorBasedOnDocument: true,
											showSelectedBalance: false
										}
									}
								},
								entering: (row) => {
									return row.account != null && row.center1 != null
								},
							},
							{
								field: 'description',
								headerName: this.$t('document.f.description'),
								type: 'description',
								validators: validators('required'),
								isEditable: true,
								cellEditorParams: {
									options: (params) => {
										return {
											entityType: 'Account',
											entityId: params.data?.account ? params.data?.account.id : null,
											entityTitle: params.data?.account ? params.data?.account.name : '',
											includePublic: true
										}
									}
								}
							},
							{
								field: 'currencyValues',
								headerName: this.$t('document.f.debtor'),
								type: 'multiCurrency',
								isEditable: true,
								cellRendererParams: {
									options: {
										targetValuePropertyName: 'debit',
									},
								},
								cellEditorParams: {
									options: () => {
										return {
											targetValuePropertyName: 'debit',
											isNameVisible: false,
										}
									}
								},
								valueSetter: (params) => {
									if (isEqual(params.newValue, params.oldValue)) return false

									const row = params.data
									row.currencyValues = params.newValue

									let res = row.currencyValues.reduce(
										(res, item) => {
											res.debit +=
												toFloat(item.debit) + toFloat(item.debitCurrency)
											res.credit +=
												toFloat(item.credit) + toFloat(item.creditCurrency)
											return res
										},
										{ debit: 0, credit: 0 }
									)

									if (res.credit > 0 && res.debit > 0) {
										row.currencyValues = row.currencyValues.map((item) => {
											return _.extend(item, { credit: '0', creditCurrency: '0' })
										})
									}


									return true
								},
								entering: (row) => {
									return row.account != null
								},
								validators: validators(
									new VCustom(
										this.validateCurrencyValues,
										this.validateErrorGenerator
									)
								),
								comparator: (valueA, valueB, nodeA, nodeB) => {
									if ((Number(valueA[0].debit) || 0) > (Number(valueB[0].debit) || 0))
										return 1
									else if ((Number(valueA[0].debit) || 0) < (Number(valueB[0].debit) || 0))
										return -1
									else
										return 0
								},
							},
							{
								field: 'currencyValues',
								headerName: this.$t('document.f.creditor'),
								type: 'multiCurrency',
								isEditable: true,
								credit: true,
								cellRendererParams: {
									options: {
										targetValuePropertyName: 'credit',
									},
								},
								cellEditorParams: {
									options: () => {
										return {
											targetValuePropertyName: 'credit',
											isNameVisible: false,
										}
									}
								},
								valueSetter: (params) => {
									if (isEqual(params.newValue, params.oldValue)) return false

									const row = params.data
									row.currencyValues = params.newValue

									let res = row.currencyValues.reduce(
										(res, item) => {
											res.debit +=
												toFloat(item.debit) + toFloat(item.debitCurrency)
											res.credit +=
												toFloat(item.credit) + toFloat(item.creditCurrency)
											return res
										},
										{ debit: 0, credit: 0 }
									)

									if (res.credit > 0 && res.debit > 0) {
										row.currencyValues = row.currencyValues.map((item) => {
											return _.extend(item, { debit: '0', debitCurrency: '0' })
										})
									}

									return true
								},
								entering: (row) => {
									return row.account != null
								},
								aggregateFunction: (values) => {
									const creditSum = SumBy(values, (item) => Number(item[0].credit))
									const debitSum = SumBy(values, (item) => Number(item[0].debit))
									return [{ credit: String(creditSum), debit: String(debitSum) }]
								},
								comparator: (valueA, valueB, nodeA, nodeB) => {
									if ((Number(valueA[0].credit) || 0) > (Number(valueB[0].credit) || 0))
										return 1
									else if ((Number(valueA[0].credit) || 0) < (Number(valueB[0].credit) || 0))
										return -1
									else
										return 0
								},
							},
							{
								field: 'date',
								headerName: this.$t('document.f.trackDate'),
								type: 'date',
								isEditable: true,
								entering: (row) => {
									return row.account != null
								},
							},
							{
								field: 'trackNumber',
								headerName: this.$t('document.f.trackNumber'),
								type: 'string',
								isEditable: true,
								entering: (row) => {
									return row.account != null
								},
							},
							{
								field: 'count',
								headerName: this.$t('document.f.count'),
								type: 'number',
								isEditable: true,
								entering: (row) => {
									return row.account != null
								},
							},
							{
								field: 'descriptionAlternative',
								headerName: this.$t(
									'document.descriptionAlternative'
								).toLocaleDigits(),
								type: 'description',
								cellEditorParams: {
									options: (params) => {
										return {
											entityType: 'Account',
											entityId: params.data?.account ? params.data?.account.id : null,
											entityTitle: params.data?.account ? params.data?.account.name : '',
											includePublic: true
										}
									}
								},
								isEditable: true,
								entering: (row) => {
									return row.account != null
								},
							},
						]
					}
				},
				currencyCols: [
					{
						field: 'currencyValues',
						headerName: this.$t('document.f.currency'),
						type: 'multiCurrency',
						isEditable: true,
						validators: validators(
							new VCustom(
								(currencyValues, row) => {
									if (row.account && row.account.acceptsCurrency && !row.currencyValues[0].currency?.id)
										return false

									return true
								},
								() => {
									return this.$t('document.m.account-required-currency')
								}
							)
						),
						cellRendererParams: {
							options: {
								targetValuePropertyName: 'currency',
							},
						},
						cellEditorParams: {
							options: () => {
								return {
									targetValuePropertyName: 'currency',
									isNameVisible: false,
								}
							}
						},
						entering: (row) => {
							return row.account != null
						},
						leaving: (row) => {
							return true
						},
					},
					{
						field: 'currencyValues',
						headerName: this.$t('document.f.currencyRate'),
						type: 'multiCurrency',
						isEditable: true,
						validators: validators(
							new VCustom(
								(currencyValues, row) => {
									if (row.account && row.account.acceptsCurrency && !row.currencyValues[0].currencyRate)
										return false

									return true
								},
								() => {
									return this.$t('document.m.account-required-currency')
								}
							)
						),
						cellRendererParams: {
							options: {
								targetValuePropertyName: 'currencyRate',
							},
						},
						cellEditorParams: {
							options: () => {
								return {
									targetValuePropertyName: 'currencyRate',
									isNameVisible: false,
								}
							}
						},
						entering: (row) => {
							return row.account != null
						},
						leaving: (row) => {
							return true
						},
					},
					{
						field: 'currencyValues',
						headerName: this.$t('document.f.debitCurrency'),
						type: 'multiCurrency',
						isEditable: true,
						validators: validators(
							new VCustom(
								(currencyValues, row) => {
									if (!row.account || !row.account.acceptsCurrency) return true

									if (!currencyValues || !currencyValues.length) return false

									let allZero =
										currencyValues.filter((x) => x.debitCurrency > 0).length ===
										0 && currencyValues.filter((x) => x.debit > 0).length > 0
									if (allZero) return false

									return true
								},
								() => {
									return this.$t('document.m.account-required-currency')
								}
							)
						),
						valueSetter: (params) => {
							if (isEqual(params.newValue, params.oldValue)) return false

							const row = params.data
							row.currencyValues = params.newValue

							let res = row.currencyValues.reduce(
								(res, item) => {
									res.debit += toFloat(item.debit) + toFloat(item.debitCurrency)
									res.credit += toFloat(item.credit) + toFloat(item.creditCurrency)
									return res
								},
								{ debit: 0, credit: 0 }
							)

							if (res.credit > 0 && res.debit > 0) {
								row.currencyValues = row.currencyValues.map((item) => {
									return _.extend(item, { credit: '0', creditCurrency: '0' })
								})
							}

							return true
						},
						cellRendererParams: {
							options: {
								targetValuePropertyName: 'debitCurrency',
							},
						},
						cellEditorParams: {
							options: () => {
								return {
									targetValuePropertyName: 'debitCurrency',
									isNameVisible: false,
								}
							}
						},
						entering: (row) => {
							return row.account != null
						},
					},
					{
						field: 'currencyValues',
						headerName: this.$t('document.f.creditCurrency'),
						type: 'multiCurrency',
						isEditable: true,
						validators: validators(
							new VCustom(
								(currencyValues, row) => {
									if (!row.account || !row.account.acceptsCurrency) return true

									if (!currencyValues || !currencyValues.length) return false

									let allZero =
										currencyValues.filter((x) => x.creditCurrency > 0).length ===
										0 && currencyValues.filter((x) => x.credit > 0).length > 0
									if (allZero) return false

									return true
								},
								() => {
									return this.$t('document.m.account-required-currency')
								}
							)
						),
						cellRendererParams: {
							options: {
								targetValuePropertyName: 'creditCurrency',
							},
						},
						cellEditorParams: {
							options: () => {
								return {
									targetValuePropertyName: 'creditCurrency',
									isNameVisible: false,
								}
							}
						},
						valueSetter: (params) => {
							if (isEqual(params.newValue, params.oldValue)) return false

							const row = params.data
							row.currencyValues = params.newValue

							let res = row.currencyValues.reduce(
								(res, item) => {
									res.debit +=
										toFloat(item.debit) + toFloat(item.debitCurrency)
									res.credit +=
										toFloat(item.credit) + toFloat(item.creditCurrency)
									return res
								},
								{ debit: 0, credit: 0 }
							)

							if (res.credit > 0 && res.debit > 0) {
								row.currencyValues = row.currencyValues.map((item) => {
									return _.extend(item, { debit: '0', debitCurrency: '0' })
								})
							}

							return true
						},
						entering: (row) => {
							return row.account != null
						},
					},
				],
				document: {
					id: emptyId,
					code: '',
					date: null,
					type: null,
					description: null,
					details: [],
					isNew: true,
				},
				selectDetailRow: null,
				selectedAccount: null,
				allDocTypes: [],
				validators: {
					type: validators('required'),
					date: validators('required'),
				},

				buttons_prev: {
					title: this.$t('document.nav.prev'),
					shortcut: $sc.find('ctrl-move-down', 'table'),
					handle: (button, page, e) => {
						this.loadIfPossible(null, true, { direction: 'previous', id: this.document.id })
					},
					icon: 'angle-right',
					beginOfGroup: true,
				},
				buttons_next: {
					title: this.$t('document.nav.next'),
					shortcut: $sc.find('ctrl-move-up', 'table'),
					handle: (button, page, e) => {
						this.loadIfPossible(null, true, { direction: 'next', id: this.document.id })
					},
					icon: 'angle-left',
				},
				buttons_access_management: {
					title: this.$t('operationRole.claims'),
					policyClaims: 'General_Access_Management',
					handle: (button, page, e) => {
						this.showModal({
							component: defineAsyncComponent(() => import('~/views/operation-roles/access-control')),
							data: {
								prefix: 'Accounting_Document',
								accessData: this.document.id
									? {
										entityId: this.document.id,
										entityType: 'DocumentHeader',
										objectDescription: `${this.$t('document.f.code')} ${this.document.code}`,
									}
									: null,
							},
						})
							.then(() => this.defer(() => this.$refs.docCode.$el.focus(), 1))
							.catch(() => this.defer(() => this.$refs.docCode.$el.focus(), 1))
					},
					icon: 'user-lock',
				},
				button_snapshot: {
					type: 'snapshot',
					options: () => {
						return {
							fillData: this.fillDocument,
							snapshotInstance: this.snapshotInstance
						}
					}
				},
				button_refresh: {
					title: this.$t('trs.chq.oper.refresh'),
					icon: 'sync',
					handle: () => {
						this.getOpeningDocument()
					},
				},
				button_change_log: {
					title: this.$t('change-log.f.change-log'),
					handle: (button, page, e) => {
						this.getChangeLog()
					},
					icon: 'scroll',
					policyClaims: 'General_ChangeLog_List',
				},

				settings_button: {
					title: this.$t('setting.documentSettings.title'),
					handle: (button, page, e) => {
						this.showModal({
							component: defineAsyncComponent(() => import('~/views/settings/settings-document')),
						})
							.then(() => this.defer(() => this.$refs.docCode.$el.focus(), 1))
							.catch(() => this.defer(() => this.$refs.docCode.$el.focus(), 1))
					},
					icon: 'cog',
					policyClaims: 'Settings_Accounting_Document',
				},

				saveButton: {
					title: this.$t('save'),
					shortcut: $sc.find('save'),
					isPrimary: false,
					disabled: false,
					icon: 'save',
					handle: () => {
						this.trySaveDocument(this.document.type)
							.then((x) => {
								this.clearForm()
									.then(res => this.resolve())
							})
							.catch((err) => { })
					},
					policyClaims: {
						or: ['Accounting_Document_Add', 'Accounting_Document_Edit'],
					},
					selfButton: true,
					items: [],
				},
				saveAsNoteButton: {
					title: this.$t('save-as-note'),
					shortcut: $sc.find('save'),
					isPrimary: false,
					disabled: false,
					icon: 'floppy-disk-pen',
					handle: () => {
						this.trySaveDocument(this.allDocTypes.find(x => x.systemDocType === 'Note'))
							.then((x) => {

							})
							.catch((err) => { })
					},
					policyClaims: {
						or: ['Accounting_Document_Add', 'Accounting_Document_Edit'],
					},
				},
				changeStateButton: {
					title: this.$t('change-state-to-accepted'),
					isPrimary: false,
					disabled: false,
					icon: 'memo-circle-check',
					handle: () => {
						this.changeDocumentState()
					},
					policyClaims: {
						or: ['Accounting_Document_Operation'],
					},
				},
				deleteButton: {
					title: this.$t('delete'),
					shortcut: $sc.find('delete', 'document'),
					icon: 'trash',
					disabled: false,
					handle: () => {
						this.showDeleteDialog()
					},
					policyClaims: 'Accounting_Document_Delete',
				},
				addButton: {
					title: this.$t('new'),
					shortcut: $sc.find('new'),
					icon: 'plus',
					isPrimary: false,
					handle: () => {
						this.clearBoard()
					},
					policyClaims: 'Accounting_Document_Add',
				},
				printButton: {
					type: 'print',
					navMenuKey: 'Accounting',
					form: 'Document',
					getDataSources: () => this.print_dataSources(),
					isDataChanged: this.isDataChanged,
					disabled: true,
				},
				copyButton: {
					title: this.$t('document.form-buttons.copy'),
					shortcut: $sc.find('duplicate'),
					icon: 'copy',
					disabled: false,
					isPrimary: false,
					handle: () => {
						this.copy()
					},
					policyClaims: 'Accounting_Document_Copy',
				},
				attachmentButton: {
					title: this.$t('attachments'),
					shortcut: $sc.find('attachment'),
					icon: 'paperclip',
					isPrimary: false,
					handle: () => {
						this.attachments()
					},
					badgeNumber: 0,
					policyClaims: 'Accounting_Document_Attachment',
				},
				noteButton: {
					title: this.$t('note.title'),
					// shortcut: $sc.find('attachment'),
					icon: 'fal fa-comment-alt-edit',
					isPrimary: false,
					badgeNumber: 0,
					handle: () => {
						this.note()
					},
					// policyClaims: 'Accounting_Document_Attachment',
				},
				previewButton: {
					title: this.$t('document.form-buttons.show-preview-source'),
					shortcut: $sc.find('view-document'),
					icon: 'file-import',
					isPrimary: false,
					visible: false,
					handle: (button, page, e) => {
						this.showPreviewSource()
					}
				},
				maxPrintCenterLevel: 1
			}
		},
		created() {
			this.document = _.extend({}, this.document, this.data)

			if (this.document.details.length > 0 && this.$refs.table) {
				this.$refs.table.prepareData(this.document.details)
			}

			this.settings = _.extend({}, this.settings, this.options)

			if (!this.settings.extendedColumnsEnabled) {
				this.settings.table.columns[1].width = 150
				this.settings.table.columns[2].width = 'auto|>170px|<800px'
				this.settings.table.columns[3].width = 120
				this.settings.table.columns[4].width = 120
				this.settings.table.columns.splice(5)
			}
		},
		computed: {
			...mapGetters({
				getAllCurrencies: 'currencies/companyCurrencies',
				accountGetById: 'accounts/getById',
				floatingCenterGetById: 'floatingCenters/getById',
				getParentByLevel: 'accounts/getParentByLevel',
				getCentersByAccountId: 'floatingCenters/getCentersByAccountId',
				findSystemForm: 'forms/findSystemFormByKey',
				getFiscalPeriod: 'appContext/getFiscalPeriod',
				checkAccountBalanceAccess: 'appContext/checkAccessAccountBalanceObserve',

			}),
			docHeaderInfo() {
				let source = '-'
				if (this.retreiveIsEmpty())
					source = this.$t(`document.sources.manual`)
				else if (this.document?.sourceEntityType)
					source = this.document.documentGroup === GROUP_OPENING ? this.$t(`forms.Opening_Document`) : this.$t(`document.sources.${this.document.sourceEntityType.toLowerCase()}`)

				let system = '-'
				if (this.document?.system)
					system = this.$t(`badges.system.${this.document.system?.toLowerCase()}`)

				let status = '-'
				if (!this.retreiveIsEmpty() && this.document?.type)
					status = this.document?.type.name

				return {
					source,
					system,
					status
				}
			},
			docHeaderRegisteredConfig() {
				return { bg: '#FAD7A0', textColor: '#7E5109', icon: 'fa-solid fa-floppy-disk' }
			},
			docHeaderStateConfig() {
				const defaultConfig = this.docHeaderRegisteredConfig
				const configs = {
					Accepted: { bg: '#A3D1B4', textColor: '#1E4620', icon: 'fa-solid fa-circle-check' },
					Reviewed: { bg: '#A9CCE3', textColor: '#1B4F72', icon: 'fa-solid fa-eye' },
					Registered: defaultConfig,
					Note: { bg: '#D7BDE2', textColor: '#4A235A', icon: 'fa-solid fa-note-sticky' },
				}
				return configs[this.document?.type?.systemDocType] || defaultConfig
			},
			docHeaderStatusBadgeStyle() {
				return {
					backgroundColor: this.docHeaderStateConfig.bg,
					color: this.docHeaderStateConfig.textColor,
				}
			},
			docHeaderRegisteredBadgeStyle() {
				return {
					backgroundColor: this.docHeaderRegisteredConfig.bg,
					color: this.docHeaderRegisteredConfig.textColor,
				}
			},
			docHeaderShowStatus() {
				return !this.retreiveIsEmpty() && this.docHeaderInfo.status !== '-'
			},
			docHeaderShowRegisteredBadge() {
				return this.retreiveIsEmpty() && !!this.document?.type?.name
			},
			docHeaderShowSource() {
				return !this.retreiveIsEmpty() && this.docHeaderInfo.source !== '-'
			},
			docHeaderIsNew() {
				return this.retreiveIsEmpty()
			},
			docHeaderIsLocked() {
				return this.settings.mode === this.FORM_MODES.READONLY
			},
			defaultDocType() {
				return (this.allDocTypes || []).sort2('periority')[0]
			},
			TYPE_MEMO() {
				if (!this.allDocTypes) return null
				return this.allDocTypes.find(
					(x) =>
						x.name.toLowerCase().indexOf('یادداشت') !== -1 ||
						x.name.toLowerCase().indexOf('موقت') !== -1 ||
						x.name.toLowerCase().indexOf('temp') !== -1 ||
						x.name.toLowerCase().indexOf('memo') !== -1
				)
			},
			tableOptionsComputed() {

				this.settings.table.editable = this.settings.mode === this.FORM_MODES.EDITABLE

				if (this.settings.mode === this.FORM_MODES.EDITABLE)
					_.extend(this.settings.table.buttons, this.buttons)
				else
					_.extend(this.settings.table.buttons, this.prepareDisabledGridButtons())

				return this.settings.table
			},
			// documentType: {
			// 	get() {
			// 		return _.head(
			// 			this.allDocTypes.filter(
			// 				(x) => _.toLower(x.name) == _.toLower(this.document.type)
			// 			)
			// 		)
			// 	},
			// 	set(obj) {
			// 		return (this.document.type = obj.name)
			// 	},
			// },
			additionalInfoObj() {
				if (this.document) {
					let obj = [
						[`${this.$t('Auditable.CreatedBy')}`, this.document.createdBy],
						[
							`${this.$t('Auditable.Created')}`,
							this.document.created,
							'datetime',
						],
						[
							`${this.$t('Auditable.LastModifiedBy')}`,
							this.document.lastModifiedBy,
						],
						[
							`${this.$t('Auditable.LastModified')}`,
							this.document.lastModified,
							'datetime',
						],
						[
							`${this.$t('document.f.codeInSybsystem')}`,
							this.document.codeInSybsystem
						],
						[
							`${this.$t('document.f.codeInDay')}`,
							this.document.codeInDay
						],
						[
							`${this.$t('document.f.codeInReports')}`,
							this.document.codeInReports
						],
					]
					return obj
				}
				return null
			},
			defaultCurrency() {
				return this.getAllCurrencies.find((x) => x.isDefault && x.isEnabled)
			},
			selectedAccountInfo() {
				if (!this.selectedAccount) return null
				var account = this.accountGetById(this.selectedAccount.id)
				var parents = []
				const setParentPath = (account) => {
					let parent = {
						id: account.id,
						name: account.name,
						accountingCode: account.accountingCode,
						level: account.level,
					}
					if (account.parent && account.parent.id != emptyId)
						setParentPath(this.accountGetById(account.parent.id))
					parents.push(parent)
				}
				setParentPath(account)
				account.parents = parents
				return account
			},
			docTypes() {
				if (this.retreiveIsEmpty() || !this.document.type?.reports)// assumes type is memo/temp
					return this.allDocTypes.filter(x => x.insert)

				return []
			},
			accountBalance() {
				return this.checkAccountBalanceAccess && !this.selectedAccountInfo?.balanceRestricted ? parseInt(this.selectedAccountInfo.balance) : '***'
			}
		},
		watch: {
			selectDetailRow: {
				deep: true,
				immediate: true,
				handler(val, oldVal) {
					if (!val) return
					this.selectedAccount = (val[0] || {}).account
				},
			},
		},
		async mounted() {
			this.getDocValidationSettings()
			this.refreshSaveButtonItems()

			if (this.settings.id && this.settings.id !== emptyId)
				this.document.id = this.settings.id

			let formTitle = this.settings.docGroup ? this.$t(`document.${this.settings.docGroup}`) : this.$t('document.title')

			let buttons

			if (this.settings.docGroup === GROUP_OPENING) {

				buttons = [
					this.saveAsNoteButton,
					this.changeStateButton,
					this.printButton,
					this.deleteButton,
					{ type: 'seprator' },
					{ type: 'excel', module: 'system', mapSettings: { type: 'Document', documentGroup: 'Opening_Account' }, exportIds: () => this.document ? [this.document.id] : emptyId },
					this.attachmentButton,
					this.noteButton
				]
			}
			else {
				buttons = [
					this.saveButton,
					this.addButton,
					this.printButton,
					this.deleteButton,
					{ type: 'seprator' },
					this.attachmentButton,
					this.noteButton,
					{ type: 'seprator' },
					{ type: 'excel', module: 'system', mapSettings: { type: 'Document', documentGroup: this.settings.docGroup, hasProgress: true }, exportIds: () => this.document ? [this.document.id] : emptyId },
					this.copyButton,
					this.previewButton,
				]
			}

			this.prepareWindow(formTitle, buttons)

			this.$nikan.calcAutoHeight(this.$el)

			if (this.getAllCurrencies.filter((x) => x.isEnabled).length > 1)
				this.refreshTodayRates()

			await this.getDocumentTypes()
			this.getMaxCentersLevel().then((x) => {
				this.min_centers_cols = x

				if (this.settings.docGroup === GROUP_OPENING)
					this.getOpeningDocument()
				else if (this.document.id != emptyId) {
					this.getDocumentById(this.document.id)
					this.setCenterColumns(x)
					if (!this.tableToggler)
						this.tableToggler = true
				} else if (!this.options || isEmpty(this.document.id)) {
					this.clearForm()
				}

				this.setCurrencyColumns()
			})

			if (this.settings.docGroup) {
				// this.buttons_next.visible = false
				// this.buttons_prev.visible = false
				this.document.documentGroup = this.settings.docGroup
			}
		},
		methods: {
			...mapActions({
				getCentersByAccountIdAndItsParents: 'floatingCenters/getCentersByAccountIdAndItsParents',
				getMaxCentersLevelByAccountId: 'floatingCenters/getMaxCentersLevelByAccountId',
				getMaxCentersLevel: 'floatingCenters/getMaxCentersLevel',
				refreshTodayRates: 'currencies/refreshTodayRates',
				broadcastItemExist: 'socket/broadcastItemExist',
				broadcastRefresh: 'socket/broadcastRefresh'
			}),
			prepareAggregateDocumentData(document, level) {
				const prepareGroupedAccounts = () => {
					for (let detail of data.details) {
						let kol = null
						if (detail.account.level <= level)
							kol = detail.account
						else
							kol = this.getParentByLevel(detail.account.id, level)

						let group = groupedAccount.find(x => x.account.id === kol.id)
						if (group)
							group.details.push(detail)
						else
							groupedAccount.push({ account: kol, details: [detail] })
					}
				}
				const fillDebits = (groupAccount, sumDebits) => {
					debits.push({
						rowNumber: '',
						account: groupAccount.account.name,
						accountingCode: groupAccount.account.accountingCode,
						centers: '',
						detailPrice: '',
						debit: sumDebits,
						credit: '',
						description: '',
						rowType: 'kol'
					})
					debits.push(...groupAccount.details.filter(x => x.currencyValues[0].debit > 0).map(x => {
						return {
							rowNumber: '',
							account: x.account.name,
							accountingCode: x.account.accountingCode,
							centers: x.centers?.map(x => `${x.name} (${x.accountingCode})`).join(', '),
							center1: x.centers?.some(x => x.level === 1) ? `${x.centers?.find(x => x.level === 1)?.name} (${x.centers?.find(x => x.level === 1)?.accountingCode})` : '',
							center2: x.centers?.some(x => x.level === 2) ? `${x.centers?.find(x => x.level === 2)?.name} (${x.centers?.find(x => x.level === 2)?.accountingCode})` : '',
							center3: x.centers?.some(x => x.level === 3) ? `${x.centers?.find(x => x.level === 3)?.name} (${x.centers?.find(x => x.level === 3)?.accountingCode})` : '',
							detailPrice: x.currencyValues[0].debit,
							currency: x.currencyValues[0].currency ? x.currencyValues[0].currency.name : '',
							creditCurrency: x.currencyValues[0].creditCurrency || 0,
							debitCurrency: x.currencyValues[0].debitCurrency || 0,
							currencyRate: x.currencyValues[0].currencyRate || 0,
							debit: '',
							credit: '',
							description: x.description,
							rowType: 'joz'
						}
					}))
				}
				const fillCredits = (groupAccount, sumCredits) => {
					credits.push({
						rowNumber: '',
						account: groupAccount.account.name,
						accountingCode: groupAccount.account.accountingCode,
						centers: '',
						detailPrice: '',
						debit: '',
						credit: sumCredits,
						description: '',
						rowType: 'kol'
					})
					credits.push(...groupAccount.details.filter(x => x.currencyValues[0].credit > 0).map(x => {
						return {
							rowNumber: '',
							account: x.account.name,
							accountingCode: x.account.accountingCode,
							centers: x.centers?.map(x => `${x.name} (${x.accountingCode})`).join(', '),
							center1: x.centers?.some(x => x.level === 1) ? `${x.centers?.find(x => x.level === 1)?.name} (${x.centers?.find(x => x.level === 1)?.accountingCode})` : '',
							center2: x.centers?.some(x => x.level === 2) ? `${x.centers?.find(x => x.level === 2)?.name} (${x.centers?.find(x => x.level === 2)?.accountingCode})` : '',
							center3: x.centers?.some(x => x.level === 3) ? `${x.centers?.find(x => x.level === 3)?.name} (${x.centers?.find(x => x.level === 3)?.accountingCode})` : '',
							detailPrice: x.currencyValues[0].credit,
							currency: x.currencyValues[0].currency ? x.currencyValues[0].currency.name : '',
							creditCurrency: x.currencyValues[0].creditCurrency || 0,
							debitCurrency: x.currencyValues[0].debitCurrency || 0,
							currencyRate: x.currencyValues[0].currencyRate || 0,
							debit: '',
							credit: '',
							description: x.description,
							rowType: 'joz'
						}
					}))
				}
				const setRowNumbers = () => {
					let rowNumber = 1
					for (let item of data.details) {
						if (item.rowType === 'kol')
							item.rowNumber = rowNumber++
					}
				}
				let data = document
				let groupedAccount = []
				let debits = []
				let credits = []
				prepareGroupedAccounts()
				for (let groupAccount of groupedAccount) {
					let sumDebits = _.sumBy(groupAccount.details, detail => {
						return Number(detail.currencyValues[0].debit)
					})
					let sumCredits = _.sumBy(groupAccount.details, detail => {
						return Number(detail.currencyValues[0].credit)
					})
					if (sumDebits !== 0) {
						fillDebits(groupAccount, sumDebits)
					}
					if (sumCredits !== 0) {
						fillCredits(groupAccount, sumCredits)
					}
				}
				data.rows = [...debits, ...credits]
				setRowNumbers()
				return data
			},
			print_dataSources(data) {
				let clonedLocalData = _.cloneDeep(data ? data : this.document)
				if (!data) clonedLocalData.details = this.$refs.table.getTableData().data

				let maxCenterLevel = 1
				clonedLocalData.details.map((x) => {
					x.centers.forEach((center) => {
						x[`centerCode${center.level}`] = center.accountingCode
						x[`center${center.level}`] = center
						maxCenterLevel = Math.max(maxCenterLevel, center.level)
					})
				})

				const printCenterLevel = Math.max(this.maxPrintCenterLevel, maxCenterLevel)
				const separatedCenters = {}
				for (let i = 1; i <= printCenterLevel; i++) {
					separatedCenters[`center${i}`] = (item) => item ? item.name : ''
					separatedCenters[`centerCode${i}`] = (item) => item || ''
				}

				let aggregateDocumentData = _.cloneDeep(this.prepareAggregateDocumentData(clonedLocalData, 2))
				let aggregateDocumentDataMoein = _.cloneDeep(this.prepareAggregateDocumentData(clonedLocalData, 3))
				return [
					{
						name: 'AggregateDocument',
						data: aggregateDocumentData,
						translatedDataSetName: this.$t('document.aggregateDocument'),
						translatePrefix: 'document.f',
						converter: {
							type: PrintDataConvertTypes.MAPPER,
							settings: {
								code: (item, row) => row.type.systemDocType === 'Note' ? `${item} - ${row.type.name}` : item,
								attachNumber: (item, row) => row.type.systemDocType === 'Note' ? `${item} - ${row.type.name}` : item,
								codeInReports: 'codeInReports',
								codeInSybsystem: 'codeInSybsystem',
								codeInDay: 'codeInDay',
								date: 'date',
								system: (item, row) => this.$t(`badges.system.${item.toLowerCase()}`),
								sumCredits: 'sumCredits',
								sumDebits: 'sumDebits',
								user: 'user.userName',
								rows: {
									rowNumber: 'rowNumber',
									accountingCode: 'accountingCode',
									account: 'account',
									centers: 'centers',
									center1: 'center1',
									center2: 'center2',
									center3: 'center3',
									detailPrice: 'detailPrice',
									debit: 'debit',
									credit: 'credit',
									debitCurrency: 'debitCurrency',
									creditCurrency: 'creditCurrency',
									currency: 'currency',
									currencyRate: 'currencyRate',
									rowType: 'rowType',
									description: 'description'
								}
							}
						},
					},
					{
						name: 'AggregateDocumentMoein',
						data: aggregateDocumentDataMoein,
						translatedDataSetName: this.$t('document.aggregateDocumentMoein'),
						translatePrefix: 'document.f',
						converter: {
							type: PrintDataConvertTypes.MAPPER,
							settings: {
								code: (item, row) => row.type.systemDocType === 'Note' ? `${item} - ${row.type.name}` : item,
								attachNumber: (item, row) => row.type.systemDocType === 'Note' ? `${item} - ${row.type.name}` : item,
								codeInReports: 'codeInReports',
								codeInSybsystem: 'codeInSybsystem',
								codeInDay: 'codeInDay',
								date: 'date',
								system: (item, row) => this.$t(`badges.system.${item.toLowerCase()}`),
								sumCredits: 'sumCredits',
								sumDebits: 'sumDebits',
								user: 'user.userName',
								rows: {
									rowNumber: 'rowNumber',
									accountingCode: 'accountingCode',
									account: 'account',
									centers: 'centers',
									center1: 'center1',
									center2: 'center2',
									center3: 'center3',
									detailPrice: 'detailPrice',
									debit: 'debit',
									credit: 'credit',
									debitCurrency: 'debitCurrency',
									creditCurrency: 'creditCurrency',
									currency: 'currency',
									currencyRate: 'currencyRate',
									rowType: 'rowType',
									description: 'description'
								}
							}
						},
					},
					{
						name: 'Document',
						data: clonedLocalData,
						translatedDataSetName: this.$t('nav.document'),
						translatePrefix: 'document.f',
						converter: {
							type: PrintDataConvertTypes.MAPPER,
							settings: {
								code: (item, row) => row.type.systemDocType === 'Note' ? `${item} - ${row.type.name}` : item,
								attachNumber: (item, row) => row.type.systemDocType === 'Note' ? `${item} - ${row.type.name}` : item,
								codeInReports: 'codeInReports',
								codeInSybsystem: 'codeInSybsystem',
								codeInDay: 'codeInDay',
								date: 'date',
								system: (item, row) => this.$t(`badges.system.${item.toLowerCase()}`),
								sumCredits: 'sumCredits',
								sumDebits: 'sumDebits',
								user: 'user.userName',
								description: 'description',
								details: {
									account: 'account.name',
									accountingCode: 'account.accountingCode',
									trackDate: (item, row) => !row.date || row.date.includes('0001-01-01') ? '' : row.date,
									centers: (item, row) => item.map(x => x.name).join(', '),
									...separatedCenters,
									trackNumber: 'trackNumber',
									count: 'count',
									description: 'description',
									descriptionAlternative: 'descriptionAlternative',
									debit: (item, row) => row.currencyValues[0].debit,
									credit: (item, row) => row.currencyValues[0].credit,
									debitCurrency: (item, row) => row.currencyValues[0].debitCurrency || 0,
									creditCurrency: (item, row) => row.currencyValues[0].creditCurrency || 0,
									currency: (item, row) => row.currencyValues[0].currency ? row.currencyValues[0].currency.name : '',
									currencyRate: (item, row) => row.currencyValues[0].currencyRate
								}
							}
						},
					},
				]
			},
			snapshot() {
				return {
					form: 'document-issue',
					isDataChanged: this.isDataChanged,
					retrieveData: () => {
						var snap = _.cloneDeep(this.document)

						if (this.$refs && this.$refs.table)
							snap.details = this.$refs.table.getTableData().data

						return snap
					}
				}
			},
			setFormMode(document = this.document) {

				if (!this.options || !this.options.mode)
					this.settings.mode = document.system !== 'Accounting' || (!document.type.edit && !this.retreiveIsEmpty()) || (this.settings.docGroup !== GROUP_OPENING && document.documentGroup === GROUP_OPENING) ? this.FORM_MODES.READONLY : this.FORM_MODES.EDITABLE

				this.saveButton.disabled = this.settings.mode === this.FORM_MODES.READONLY

				this.deleteButton.disabled = this.settings.mode === this.FORM_MODES.READONLY || document.isNew || !document.type.delete
				this.copyButton.disabled = this.settings.mode === this.FORM_MODES.READONLY

				this.noteButton.disabled = document.isNew
				this.printButton.disabled = document.isNew
				this.attachmentButton.disabled = document.isNew
				this.previewButton.visible = !isEmpty(document.sourceEntityType) && document.documentGroup !== GROUP_OPENING

				const editableState = this.settings.gridOptions.options.isEditable
				this.settings.gridOptions.options.isEditable = this.settings.mode === this.FORM_MODES.EDITABLE

				if (editableState !== this.settings.gridOptions.options.isEditable)
					this.$refs.table.prepareOptions(this.settings.gridOptions.options)
			},
			prepareDisabledGridButtons(ignoreKeys = ['sumBtn']) {
				var disabledButtons = _.cloneDeep(this.buttons)
				var btnKeys = Object.keys(disabledButtons)

				for (let index = 0; index < btnKeys.length; index++) {

					var ignoreIndex = ignoreKeys.indexOf(btnKeys[index])

					if (ignoreIndex > -1) {
						disabledButtons[ignoreKeys[ignoreIndex]].options.disabled = false
						continue
					}
					disabledButtons[btnKeys[index]].options.disabled = true

				}
				return disabledButtons
			},
			getDocValidationSettings() {
				post(Endpoints.getUrl('settings.get'), null, null, { preventConcurrent: false })
					.then((result) => {
						let requiredFields = JSON.parse(result.data.documentSettings.requiredFieldsJson) || []
						let trackNumber = this.settings.gridOptions.columns.find(x => x.field == 'trackNumber')
						if (trackNumber)
							trackNumber.validators = requiredFields.indexOf('trackNumber') > -1 ? validators('required') : ''

						let trackDate = this.settings.gridOptions.columns.find(x => x.field == 'date')
						if (trackDate)
							trackDate.validators = requiredFields.indexOf('trackDate') > -1 ? validators('required') : ''

						let count = this.settings.gridOptions.columns.find(x => x.field == 'count')
						if (count)
							count.validators = requiredFields.indexOf('count') > -1 ? validators('required') : ''

					})
					.catch(() => {
					})
			},
			sumOfRows() {
				if (!this.selectDetailRow || this.selectDetailRow.length === 0)
					return this.$toast(this.$t('document.m.select-row'))
				if (this.selectDetailRow.length > 1)
					return this.$toast(this.$t('document.m.select-only-one-row'))
				this.$refs.table.commitChanges().then(res => {
					var sumCredit = 0
					var sumDebit = 0
					let sliced = res.slice(0, this.$refs.table.activeRowIndex)
					sliced.forEach(row => {
						sumCredit += parseFloat(row.currencyValues[0].credit)
						sumDebit += parseFloat(row.currencyValues[0].debit)
					})
					this.$toast(this.$t('document.f.sum', { credit: sumCredit.toString().toPriceFormat(), debit: sumDebit.toString().toPriceFormat() }))
				})
			},
			loadIfPossible(code, useToast = true, navigateOptions = null, forceLoad) {
				let methods = {
					retreiveIsEmpty: this.retreiveIsEmpty,
					fillData: this.fillDocument,
					getData: this.getDocumentByCode,
					clearForm: this.clearForm,
					changedFormAlert: this.changedFormAlert,
					isDataChanged: this.isDataChanged,
					navigate: this.NavigateToDocument,
					forceLoad: () => forceLoad,
					save: () => this.trySaveDocument(this.document.type),
					formType: () => this.$options.name
				}
				let data = {
					originalData: this.originalDocument,
					searchCode: code,
					fiscalPeriodId: this.document.fiscalPeriodId,
				}
				let additionalBroadcastFields = { documentGroup: this.document.documentGroup }
				this.$nikan.formUtility.loadIfPossible(methods, data, { keyword: this.$t('document.document'), useToast: useToast }, navigateOptions, additionalBroadcastFields)
			},
			getChangeLog() {
				let entityTitle
				if (this.document.id) {
					entityTitle = this.$t('change-log.f.document-log-title', {
						code: this.document.code.toLocaleDigits(),
					})
				} else {
					entityTitle = this.$t('change-log.f.documents-log-title')
				}
				this.showModal({
					component: defineAsyncComponent(() => import('~/components/form/change-log/change-log.vue')),
					options: {
						entityId: this.document.id,
						entityType: 'DocumentHeader',
						entityTitle: entityTitle,
					},
				})
					.then(() => this.defer(() => this.$refs.docCode.$el.focus(), 1))
					.catch(() => this.defer(() => this.$refs.docCode.$el.focus(), 1))
			},
			refreshSaveButtonItems() {
				var that = this
				let items = [{
					title: this.$t('save-print'),
					icon: 'save',
					shortcut: $sc.find('save-print'),
					handle: (button, page, e) => {
						this.trySaveDocument(this.document.type)
							.then((x) => {
								this.getDocumentById(x.documentHeaderId).then(() => {
									this.defer(() => {
										this.printButton.printDefaultDesign(true, true).then(() => {
										}).catch((e) => { }).finally(() => {
											this.clearForm()
												.then(res => this.resolve())
										})
									}, 500)
								})
							}).catch(() => { })
					},
				},
				{
					title: this.$t('save-no-clear'),
					icon: 'save',
					shortcut: $sc.find('save-new'),
					handle: (button, page, e) => {
						this.trySaveDocument(this.document.type)
							.then((x) => {
								this.getDocumentById(x.documentHeaderId)
							}).catch(() => { })
					},
				}]
				for (let index = 0; index < this.docTypes.length; index++) {
					items.push({
						title: this.$t('document.v.save-as', { type: this.docTypes[index].name }),
						icon: 'save',
						handle: (button, page, e) => {
							that.trySaveDocument(that.docTypes[index])
								.then((x) => {
									that.clearForm()
								})
								.catch()
						},
					})
				}
				this.saveButton.items = items
			},
			generateEmptyRow(item) {
				item = item || {}
				let obj = {}
				obj.account = item.account || null
				obj.centers = item.centers || []
				obj.currencyValues = item.currencyValues || [
					{
						credit: 0,
						debit: 0,
						debitCurrency: 0,
						creditCurrency: 0,
						currency: {},
					},
				]
				obj.isReadOnly = false
				obj.count = ''
				obj.date = null
				obj.description = item?.description || ''
				obj.descriptionAlternative = ''
				obj.trackNumber = ''
				obj.rowState = 'new'
				return obj
			},
			showCentersTurnOver() {
				if (!this.selectedAccount) {
					dialog({
						title: this.$t('notifications.titles-attention'),
						body: this.$t('document.m.select-row'),
						type: 'warning',
						autoClose: true,
					})
					return
				}

				let centers = Object.keys(this.selectDetailRow[0]).filter((item) => {
					return item.indexOf('center') > -1 && item !== 'centers'
				}).map((i) => {
					return [this.selectDetailRow[0][i]]
				})
				this.showTurnOver(this.selectedAccount, this.selectedAccount.level, centers)
			},
			showTurnOver(account, level, centers = [], isFloatingCenter = false) {
				let filter = isFloatingCenter ? { centers: [[account]], centerInAllLevels: true } : { accounts: [account], level: level, centers: centers }

				this.showModal({
					component: defineAsyncComponent(() => import('~/views/reports/turn-over')),
					data: null,
					options: { filter: filter },
				})
					.then(() => this.defer(() => this.$refs.docCode.$el.focus(), 1))
					.catch(() => this.defer(() => this.$refs.docCode.$el.focus(), 1))
			},
			setCurrencyColumns() {
				let companyCurrencyLength = this.getAllCurrencies.filter(
					(x) => x.isEnabled
				).length
				let currentDocumentHasCurrency = false
				if (this.document) {
					(this.document.details || []).map((x) => {
						(x.currencyValues || []).map((c) => {
							if (c.currency && c.currency.id != emptyId)
								currentDocumentHasCurrency = true
						})
					})
				}

				if (companyCurrencyLength < 2 && !currentDocumentHasCurrency) {
					this.settings.gridOptions.columns = this.settings.gridOptions.columns.filter(
						(x) => !x.currency
					)
					return
				}

				if (this.settings.gridOptions.columns.filter((x) => !x.currency).length == 4)
					return

				this.settings.gridOptions.columns = this.settings.gridOptions.columns.filter(
					(x) => !x.currency
				)
				let start
				for (var i = 0; i < this.settings.gridOptions.columns.length; i++) {
					if (this.settings.gridOptions.columns[i].credit) {
						start = i
						break
					}
				}

				this.settings.gridOptions.columns.splice(start + 1, 0, ...this.currencyCols)
				this.$refs.table.prepareColumns(this.settings.gridOptions.columns)
			},
			setCenterColumns(count) {
				return new Promise((resolve, reject) => {
					var l = this.settings.gridOptions.columns.filter(
						(x) => x.field.indexOf('center') !== -1 && x.field !== 'centers'
					).length
					count = Math.max(count, this.min_centers_cols)
					this.maxPrintCenterLevel = count
					if (count > l) {
						// this.tableToggler = false
						const createCol = (index) => {
							return {
								field: 'center' + index,
								headerName: this.$t('document.center') + ` ${index}`.toLocaleDigits(),
								type: 'center',
								// width: 'auto|>100px|<800px',
								isEditable: true,
								cellEditorParams: {
									options: (params) => {
										return {
											rowIdentifier: 'id',
											searchable: true,
											required: true,
											remoteSearch: false,
											placeholder: this.$t('search-it'),
											display: (item) => `${item.accountingCode} - ${item.name}`,
											searchableFields: ['name', 'accountingCode'],
											baseAccountId: params.node.data.account != null ? params.node.data.account.id : 0,
											editable: true,
											centerLevel: index,
											selectorWidth: 400,
											locateSelectorBasedOnDocument: true,
											showSelectedBalance: false
										}
									}
								},
								entering: (row) => {
									return row.account != null && row['center' + (index - 1)] != null
								},
								validators: validators(new VRequiredIfValue('account', (val) => {
									if (val)
										return (val?.maxCenterLevel || 0) >= index
									return false
								})),
							}
						}
						var details = _.cloneDeep(this.document.details)
						for (var i = l + 1; i <= count; i++) {
							this.settings.gridOptions.columns.splice(i + 1, 0, createCol(i))
							for (var row of details) {
								if (typeof row['center' + i] === 'undefined') {
									row['center' + i] = ''
								}
							}
						}
						this.document.details = details

						// this.defer(() => {
						// 	this.tableToggler = true
						// }, 1)
						this.$refs.table.prepareColumns(this.settings.gridOptions.columns)
					}
					if (count < l) {
						this.tableToggler = false
						let startColIndex = this.settings.gridOptions.columns.findIndex(
							(x) => x.field === 'account'
						)
						this.settings.gridOptions.columns.splice(
							startColIndex + 1 + (l - count),
							l - count
						)
						var details = _.cloneDeep(this.document.details || [])
						for (var row of details) {
							let omits = []
							for (var i = l; i > l - count; i--) {
								omits.push('center' + i)
							}
							row = _.omit(row, omits)
						}
						this.document.details = details
						this.defer(() => {
							this.tableToggler = true
						}, 1)
					}
					resolve()
				})
			},
			getDocumentById(id) {
				return new Promise((resolve, reject) => {
					let data = { id: id, code: null }
					if (!isEmpty(this.settings.fiscalPeriodId))
						data.fiscalPeriodId = this.settings.fiscalPeriodId
					else if (!isEmpty(this.document.fiscalPeriodId))
						data.fiscalPeriodId = this.document.fiscalPeriodId

					if (this.settings.docGroup)
						data.documentGroup = this.settings.docGroup

					this.getDocument(data).then((response) => {
						this.fillDocument(response)
						resolve()
					}).catch(() => {
						reject()
					})
				})
			},
			getDocumentByCode(request) {
				let data = {
					id: null,
					code: request.searchCode,
					fiscalPeriodId: request.fiscalPeriodId,
				}
				if (this.settings.docGroup)
					data.documentGroup = this.settings.docGroup

				return this.getDocument(data)
			},
			fillDocument(document) {
				this.selectDetailRow = null
				this.document = this.prepareDocument(document)
				this.originalDocument = _.cloneDeep(this.document)
				this.$refs.table.prepareData(this.document.details)
				let centers = 0
				for (var i = 0; i < this.document.details.length; i++) {
					centers = Math.max(this.document.details[i].centers.length, centers)
				}
				this.refreshSaveButtonItems()
				this.setCenterColumns(centers)
				this.setFormMode()
				this.updateAttachmentsCount(document.id)
				this.updateNoteButtonStatus(document.id)
				this.selectedFloatingCenterInfo = null
			},
			getDocument(request) {
				request.pageIndex = 0
				request.pageSize = 1000
				return new Promise((resolve, reject) => {
					var wait = this.$wait(this.$refs.docCode.$el, { size: 'small' })
					post(Endpoints.getUrl('documents.get'), request, null, { silent: true })
						.then((result) => {
							wait.end()
							resolve(result.data)
						})
						.catch((err) => {
							wait.end()
							reject(err)
						})
				})
			},
			prepareDocument(data) {
				for (var i = 0; i < data.details.length; i++) {
					for (var j = 1; j <= data.details[i].centers.length; j++) {
						let level = data.details[i].centers[j - 1].level
						level = level === 0 ? j : level
						data.details[i]['center' + level] = data.details[i].centers[j - 1]
					}
					for (var j = 0; j < data.details[i].currencyValues.length; j++) {
						let item = data.details[i].currencyValues[j]
						if (
							item &&
							item.currency &&
							this.defaultCurrency &&
							item.currency.id == this.defaultCurrency.id
						)
							data.details[i].currencyValues[j].currency = {}
					}
				}
				return data
			},
			NavigateToDocument(direction, id = this.document.id) {
				if (this.settings.docGroup === GROUP_OPENING) return

				let wait = this.$wait(this.$el)

				let data = {
					id: id,
					navigationDirection: direction,
				}
				this.settings.docGroup === 'Opening_Account' && (data.documentGroup = this.settings.docGroup)
				return new Promise((resolve, reject) => {
					post(Endpoints.getUrl('documents.navigate'), data, null, { silent: true })
						.then((result) => {
							wait.end()
							resolve(result.data)
						})
						.catch((err) => {
							wait.end()
							reject(err)
						})
				})
			},
			async isDataChanged() {
				var simplifyDetail = (detail, extractCentresFromCenterFields) => {
					let centers = []
					if (extractCentresFromCenterFields) {
						for (let f in detail) {
							if (f.indexOf('center') !== -1 && f !== 'centers' && detail[f]) {
								centers.push({ id: detail[f].id, level: Number(f.replace('center', '')) })
							}
						}
					}
					else {
						centers = (detail.centers || []).map((x) => {
							return { id: x.id, level: x.level }
						})
					}
					return {
						id: detail.id,
						accountId: (detail.account || {}).id,
						centers: centers,
						description: detail.description,
						descriptionAlternative: detail.descriptionAlternative,
						date: detail.date,
						currencyValues: detail.currencyValues,
					}
				}

				var clonedDocument = _.cloneDeep(this.document)
				clonedDocument.details = this.$refs.table.getTableData().data
				clonedDocument.details = _.sortBy(clonedDocument.details, x => x.displayOrder)
				clonedDocument.code = this.originalDocument.code

				for (var detail of this.originalDocument.details) {
					detail.page = 1
				}

				var cloneOriginal = _.cloneDeep(this.originalDocument)
				cloneOriginal.details = _.sortBy(cloneOriginal.details, x => x.displayOrder)
				for (var i = 0; i < clonedDocument.details.length; i++) {
					clonedDocument.details[i] = simplifyDetail(clonedDocument.details[i], true)
				}
				for (var i = 0; i < cloneOriginal.details.length; i++) {
					cloneOriginal.details[i] = simplifyDetail(cloneOriginal.details[i], false)
				}

				const idControlProperties = [
				]
				let changed = idControlProperties.some(x => idCheckChanged(x, clonedDocument, cloneOriginal))


				return !_.isEqual(cloneOriginal, clonedDocument) || changed
			},
			getLastDocumentCode() {
				return new Promise((resolve, reject) => {
					var wait = this.$wait(this.$refs.docCode.$el, { size: 'small' })
					post(Endpoints.getUrl('documents.get-last-document-code'))
						.then((result) => {
							wait.end()
							resolve(result.data)
						})
						.catch((err) => {
							wait.end()
							reject(err)
						})
				})
			},
			async clearForm() {
				return this.getLastDocumentCode().then(code => {
					this.document = {
						code: (code + 1).toString(),
						date: this.$nikan.formUtility.getTodaysDate(),
						description: '',
						details: [],
						isNew: true,
						type: this.defaultDocType,
						system: 'Accounting',
					}
					this.$refs.table.prepareData(this.document.details)

					if (this.settings.docGroup === GROUP_OPENING) {
						this.document.documentGroup = GROUP_OPENING
						this.document.date = this.getFiscalPeriod.startDate

					}

					this.defer(() => this.$refs.docCode.$el.focus(), 1)

					this.setCenterColumns(this.min_centers_cols).then(x => {
						this.originalDocument = _.cloneDeep(this.document)
						this.selectedAccount = null
						if (!this.tableToggler)
							this.tableToggler = true
						this.defer(() => {
							if (this.$refs.table)
								this.originalDocument.details = this.$refs.table.getTableData().data
						}, 500)
					})
					this.refreshSaveButtonItems()
					this.setFormMode()
					this.attachmentButton.badgeNumber = ''
					this.noteButton.badgeNumber = ''
					this.selectedFloatingCenterInfo = null
				})
			},
			clearBoard() {
				this.loadIfPossible(0)
			},
			copy() {
				this.showModal({ component: defineAsyncComponent(() => import('~/views/documents/copy-from-document')) })
					.then((result) => {
						this.$refs.table.tryDeleteLastEmptyRow()
						this.defer(() => {
							this.$refs.table.addMultipleNewRows(result.data.details)
							this.$refs.docCode.$el.focus()
						}, 100)
					})
					.catch(() => this.defer(() => this.$refs.docCode.$el.focus(), 1))
			},
			attachments() {
				if (!this.document || isEmpty(this.document.id)) {
					this.$toast(this.$t('document.m.select-document'), { type: 'info' })
					return
				}
				this.showModal({
					component: defineAsyncComponent(() => import('~/components/uploader/attachment-manager')),
					options: {
						entityId: this.document.id,
						entityType: 'Document',
						entityTitle: 'سند شماره ' + this.document.code,
					},
				})
					.then((result) => { })
					.catch(() => this.defer(() => this.$refs.docCode.$el.focus(), 1)).finally(() => {
						this.updateAttachmentsCount(this.document.id)
					})
			},
			note() {
				if (!this.document || isEmpty(this.document.id)) {
					this.$toast(this.$t('document.m.select-document'), { type: 'info' })
					return
				}
				this.showModal({
					component: NoteManger,
					options: {
						entityId: this.document.id,
						entityType: 'Document',
						entityTitle: 'سند شماره ' + this.document.code,
					},
				})
					.then((result) => { })
					.catch(() => this.defer(() => this.$refs.docCode.$el.focus(), 1)).finally(() => {
						this.updateNoteButtonStatus(this.document.id)
					})
			},
			allDocuments() {
				this.showModal({ component: DocsList, options: { multiselection: false, selectedRow: this.document, documentGroup: this.settings.docGroup } })
					.then((result) => {
						this.loadIfPossible(result.code, true, null, true)
						this.defer(() => this.$refs.docCode.$el.focus(), 1)
					})
					.catch(() => this.defer(() => this.$refs.docCode.$el.focus(), 1))
			},
			findAccount(detail, dd, text) {
				if (detail.account == null && text !== '') {
					console.log(`trying to find account with exact match ${text}`)
				}
			},
			docCodeBlur() {
				if (this.originalDocument && !this.onCodeEnterPressed && !this.$refs.docCode) {
					this.loadIfPossible(this.document.code, false)
				}
				this.onCodeEnterPressed = false
			},
			changedFormAlert(act, params) {
				return new Promise((resolve, reject) => {
					dialog({
						title: this.$t('document.m.unsaved-doc.title'),
						body: this.$t('document.m.unsaved-doc.body', {
							docCode: this.originalDocument.code,
						}),
						buttons: [
							{
								title: this.$t('document.dialog.saveAsSaved'),
								shortcut: $sc.find('yes', 'dialog'),
								isPrimary: true,
								handle: (button, page, e) => {
									this.document.code = this.originalDocument.code
									this.trySaveDocument(this.document.type)
										.then((response) => {
											this.$refs.docCode.$el.focus()
											act(params)
										})
										.then(() => resolve())
										.catch((error) => reject(error))
								},
							},
							{
								title: this.$t('document.dialog.saveAsMemo'),
								shortcut: $sc.find('yesAs', 'dialog'),
								isPrimary: true,
								visible: (this.retreiveIsEmpty() || !this.document.type.reports),
								handle: (button, page, e) => {
									this.document.code = this.originalDocument.code
									if (!this.TYPE_MEMO) {
										dialog({
											title: this.$t('notifications.titles-warning'),
											body: this.$t('account.m.type-memo-not-found'),
											type: 'error',
										})
										return
									}
									this.trySaveDocument(this.TYPE_MEMO)
										.then((response) => {
											this.$refs.docCode.$el.focus()
											act(params)
										})
										.then(() => resolve())
										.catch((error) => reject(error))
								},
							},
							{
								title: this.$t('document.dialog.ignoreChanges-load'),
								shortcut: $sc.find('ignore-changes', 'document'),
								isPrimary: true,
								handle: (button, page, e) => {
									act(params)
									resolve()
								},
							},
							{
								title: this.$t('dialog.return'),
								shortcut: $sc.find('return', 'dialog'),
								isCancel: true,
								handle: (button, page, e) => {
									reject()
								},
							},
						],
					})
				})
			},
			async trySaveDocument(type) {
				if (this.document.system !== 'Accounting') {
					let subSystem = this.$t(`document.system.${this.document.system.toLowerCase()}`)
					throw this.$toast(this.$t('document.m.save.cant-edit-from-subsystem', { subSystem: subSystem }), { type: 'info' })
				}

				try {
					let details = await this.$refs.table.commitChanges()

					if (type === TYPE_SAVED) {
						await this.ensureAccountNatureIsValid(details)
					}

					if (!this.validateInputs(details, type))
						throw ''

					var saveRes = await this.saveDocumentInServer(details, type)

					this.close()
					return saveRes
				} catch (invalidRows) {
					throw invalidRows
				}
			},
			async saveDocumentInServer(details, type) {
				let clone = _.cloneDeep(this.document)
				clone.details = details
				clone.type = type || clone.type


				if (clone.system !== 'Accounting') {
					let subSystem = this.$t(`document.system.${clone.system.toLowerCase()}`)
					return this.$toast(this.$t('document.m.save.cant-edit-from-subsystem', { subSystem: subSystem }))
				}

				clone = this.prepareDocumentForSave(clone)

				var wait = this.$wait(this.grandParent)

				var that = this
				let result = {}
				var data = {
					DocumentHeader: clone,
				}
				try {
					if (clone.isNew) {
						result = await post(Endpoints.getUrl('documents.create'), data)
					} else {
						result = await post(Endpoints.getUrl('documents.update'), data)
					}

					wait.end()
					this.broadcastRefresh('Accounts')
					// this.broadcastRefresh('FloatingCenters')

					this.broadcastItemExist({ form: this.$t('document.document'), code: result.data.savedDocumentNumber })
					this.$toast(this.$t('document.m.save.success', { docCode: result.data.savedDocumentNumber }), { type: 'success' })

					if (this.settings.docGroup === GROUP_OPENING) {
						this.getOpeningDocument()
					}
					return result.data
					throw new Error('validation error')
				} catch (e) {
					wait.end()
					throw e
				}
			},
			prepareDocumentForSave(document) {
				for (var detail of document.details) {
					detail.centers = []
					for (var f in detail) {
						if (f.indexOf('center') !== -1 && f !== 'centers' && detail[f]) {
							detail[f].level = Number(f.replace('center', ''))
							detail.centers.push(detail[f])
						}
						if (detail.count == '') {
							detail.count = 0
						}
					}
				}

				if (document.isNew) {
					document.id = emptyId
					for (var i = 0; i < document.details.length; i++) {
						document.details[i].id = emptyId
						for (var j = 0; j < document.details[i].currencyValues.length; j++) {
							document.details[i].currencyValues[j].id = emptyId
						}
					}
				}
				return document
			},
			ensureAccountNatureIsValid(details) {
				return new Promise((resolve, reject) => {
					let invalidNatureRows = []
					let balance

					for (let i = 0; i < details.length; i++) {
						let row = details[i]

						if (row.rowState !== 'new' || invalidNatureRows.indexOf(row) > -1) {
							continue
						}

						balance = row.account.balance + row.credit - row.debit

						if (
							(_.get(row, 'account.accountNature.name') === 'creditor' &&
								balance < 0) ||
							(_.get(row, 'account.accountNature.name') === 'debtor' &&
								balance > 0)
						) {
							invalidNatureRows.tryPush(
								{ row, balance },
								(other, self) => other.row === row
							)
						}
					}

					if (!invalidNatureRows.length) {
						resolve()
						return
					}

					let accountName = invalidNatureRows
						.map(
							(item) =>
								item.row.account.name +
								' (' +
								helpers.formatBalance(item.balance) +
								')'
						)
						.join('<br/>')

					dialog({
						title: this.$t('document.m.invalid-nature.title'),
						body: this.$t('document.m.invalid-nature.body', {
							account: accountName,
						}),
						type: 'warning',
						autoClose: true,
						buttons: [
							{
								title: this.$t('dialog.yes'),
								shortcut: $sc.find('yes', 'dialog'),
								isPrimary: true,
								handle: (button, page, e) => {
									resolve()
								},
							},
							{
								title: this.$t('dialog.cancel'),
								shortcut: $sc.find('cancel', 'dialog'),
								isCancel: true,
								handle: (button, page, e) => {
									reject(new Error('canceled'))
								},
							},
						],
					})
				})
			},
			validateInputs(details, docType) {
				let checker = new Checker((type) => this.$t(`document.f.${type}`))
				let errors = checker.test(this.document, this.validators)

				if (details.length === 0 && this.settings.docGroup === GROUP_OPENING) {
					errors.push({
						key: '',
						error: this.$t('document.v.details-should-not-be-empty')
					})
				}
				details = details.filter(x => x.rowState !== 'deleted')

				if (!docType.edit && this.settings.docGroup !== GROUP_OPENING)
					errors.push({
						key: '',
						error: this.$t('document.v.type-not-editable', { type: docType.name })
					})

				if (!docType.nonBalance) {

					if (details.length < 2)
						errors.push({
							key: '',
							error: this.$t('document.m.must-be-atleast-two-rows')
						})

					var sumCredit = 0
					var sumDebit = 0

					details.map(row => {
						row.currencyValues.map(currency => {
							sumCredit += parseFloat(currency.credit || 0)
							sumDebit += parseFloat(currency.debit || 0)
						})
					})

					if (sumCredit !== sumDebit) {
						errors.push({
							key: '',
							error: this.$t('document.v.debit-credit-sum', { type: docType.name })
						})
					}
				}

				this.validationToast(errors)
				return errors.length === 0
			},
			async getDocumentTypes() {
				// let wait = this.$wait(this.$refs.docType.$el, { size: 'small' })

				let result = await this.cache_getOrSet(
					`documentTypes_key`,
					0,
					await this.downloadDocumentTypes
				).then((items) => {
					this.allDocTypes = items
					return items
				})
				// wait.end()
				return result
			},
			downloadDocumentTypes() {
				return post(Endpoints.getUrl('documentTypes.list')).then(
					(result) => result.data.items
				)
			},
			validateAccount(account, row) {
				return false
			},
			validateCurrencyValues(currencyValues, row) {
				if (!currencyValues || !currencyValues.length) return false

				let cvs = currencyValues.map((item) => {
					return {
						debit: toFloat(item.debit),
						credit: toFloat(item.credit),
						currency: item.currency,
					}
				})

				let invalidValues =
					cvs.filter(
						(x) => (x.debit && x.debit < 0) || (x.credit && x.credit < 0)
					).length > 0
				if (invalidValues) return false

				let doubleFull = cvs.filter((x) => x.debit > 0 && x.credit > 0).length > 0
				if (doubleFull) return false

				let arr = cvs.reduce((vals, current) => {
					return vals.concat([current.debit, current.credit])
				}, [])
				let zeroFull = arr.filter((x) => !isEmpty(x)).length === 0
				if (zeroFull) return false

				return true
			},
			validateAcceptsCurrency(currencyValues, row) {
				if (!currencyValues || !currencyValues.length) return false

				let cvs = currencyValues.map((item) => {
					return {
						debit: toFloat(item.debit),
						credit: toFloat(item.credit),
						currency: item.currency,
					}
				})

				let invalidValues =
					cvs.filter(
						(x) => (x.debit && x.debit < 0) || (x.credit && x.credit < 0)
					).length > 0
				if (invalidValues) return false

				let doubleFull = cvs.filter((x) => x.debit > 0 && x.credit > 0).length > 0
				if (doubleFull) return false

				let arr = cvs.reduce((vals, current) => {
					return vals.concat([current.debit, current.credit])
				}, [])
				let zeroFull = arr.filter((x) => !isEmpty(x)).length === 0
				if (zeroFull) return false

				return true
			},
			validateErrorGenerator(propName) {
				return this.$t('msg.required', [propName])
			},
			retreiveIsEmpty() {
				if (isEmpty(this.document.id)) {
					return true
				} else {
					return false
				}
			},
			emitedDefaultDate(value) {
				if (this.originalDocument) this.originalDocument.date = value
			},
			addRow(button, e) {
				e.preventDefault()

				if (!this.$refs.table) return

				let data = this.$refs.table.getTableData().data || []
				if (data.length > 0) {
					let lastItem = data[data.length - 1]
					delete lastItem.displayOrder
					delete lastItem.page
					delete lastItem.rowState
					delete lastItem.id
					let empty = this.generateEmptyRow()
					if (_.isEqual(lastItem, empty)) return
				}
				this.$refs.table.row_tryAddEmpty(false)
				this.defer(() => {
					this.$refs.table.focus_scrollToActiveRow()
					this.$refs.table.focus_focusCurrentLocation(false)
				}, 10)
			},
			deleteRow(button, e) {
				e.preventDefault()
				if (!this.$refs.table) return

				this.$refs.table.row_deleteSelectedRows()
			},
			duplicateRows(button, e) {
				e.preventDefault()
				if (!this.$refs.table) return
				this.$refs.table.duplicateRows(null, null, (row) => {
					for (var i = 0; i < row.currencyValues.length; i++) {
						row.currencyValues[i].id = emptyId
					}
				})
			},
			showDeleteDialog() {
				if (!this.document || !this.document.id || this.document.id == emptyId) {
					this.$toast(this.$t('document.m.delete.error.in-new-state'), { type: 'info' })
					return
				}

				if (!this.document.type.delete) {
					this.validationToast([{
						key: '',
						error: this.$t('document.v.type-not-editable', { type: this.document.type.name })
					}])
					return
				}

				if (this.document.details.some(x => x.fromOtherModule)) {
					this.$toast(this.$t('document.m.delete.error.other-modules-can-not-delete'), { type: 'error' })
					return
				}

				dialog({
					title: this.$t('document.m.delete.title'),
					body: this.$t('document.m.delete.want-to-delete', {
						code: this.document.code.toString().toLocaleDigits(),
					}),
					type: 'warning',
					autoClose: true,
					buttons: [
						{
							title: this.$t('dialog.yes'),
							shortcut: $sc.find('yes', 'dialog'),
							isPrimary: true,
							handle: (button, page, e) => {
								this.deleteDocument()
							},
						},
						{
							title: this.$t('dialog.cancel'),
							shortcut: $sc.find('cancel', 'dialog'),
							isCancel: true,
							handle: (button, page, e) => { },
						},
					],
				})
			},
			deleteDocument() {
				var wait = this.$wait(this.grandParent)
				let documentCode = this.document.code
				post(Endpoints.getUrl('documents.delete'), {
					DocumentHeaderId: this.document.id,
				})
					.then((result) => {
						wait.end()
						this.broadcastRefresh('Accounts')
						// this.broadcastRefresh('FloatingCenters')
						this.$toast(this.$t('document.m.delete.success-body', {
							code: documentCode,
						}), { type: 'success' })
						this.clearForm()
					})
					.catch(() => {
						wait.end()
					})
			},
			getOpeningDocument() {
				const wait = this.$wait(this.grandParent)
				post(Endpoints.getUrl('documents.get-opening'), {}, null, { silent: true })
					.then(res => {
						this.fillDocument(res.data)
						const isAccepted = res.data.type.systemDocType === 'Accepted'

						this.changeStateButton.title = isAccepted ? this.$t('change-state-to-memo') : this.$t('change-state-to-accepted')
						this.changeStateButton.icon = isAccepted ? 'file-pen' : 'memo-circle-check'

						this.saveAsNoteButton.visible = !isAccepted
					}).catch(() => {
						this.clearForm()
						this.changeStateButton.disabled = true
						this.saveAsNoteButton.visible = true
					}).finally(() => {
						wait.end()
					})
			},
			footerPageButtons() {
				if (this.settings.hideFooterButtons)
					return []

				var button_array
				if (this.settings.docGroup === GROUP_OPENING) {
					button_array = [
						this.button_change_log,
						this.buttons_access_management,
						this.button_snapshot,
						this.button_refresh
					]
				} else {
					button_array = [
						this.buttons_prev,
						this.buttons_next,
						this.button_change_log,
						this.buttons_access_management,
						this.settings_button,
						this.button_snapshot
					]
				}
				return button_array
			},
			showPreviewSource() {
				if (isEmpty(this.document) || isEmpty(this.document.id)) {
					this.$toast(this.$t('document.operations.no-document-selected'), { type: 'info' })
					return
				}
				this.showModal({
					component: PreviewContainer,
					// component: defineAsyncComponent(() => import('~/components/form/preview-container')),
					data: null,
					options: { entityType: this.document.sourceEntityType, entityId: this.document.sourceEntityId },
				})
					.then(() => this.defer(() => this.$refs.docCode.$el.focus(), 1))
					.catch(() => this.defer(() => this.$refs.docCode.$el.focus(), 1))
			},
			async changeDocumentState() {
				if (await this.isDataChanged()) {
					this.$toast(this.$t('document.m.save-changed-data-before-change-state'), { type: 'info' })
					return
				}

				const targetType = this.document.type.systemDocType === 'Accepted' ? this.allDocTypes.find(x => x.systemDocType === 'Note') : this.allDocTypes.find(x => x.systemDocType === 'Accepted')
				const details = this.$refs.table.getTableData().data || []

				if (!this.validateInputs(details, targetType)) return


				dialog({
					title: this.$t('document.operations.change-state-title'),
					body: this.$t('document.operations.change-state-body-single', { newState: targetType.name }),
					autoClose: true,
					type: 'warning',
					buttons: [
						{
							title: this.$t('dialog.yes'),
							shortcut: $sc.find('yes', 'dialog'),
							isPrimary: true,
							handle: (button, page, e) => {
								const wait = this.$wait(this.$el)
								post(Endpoints.getUrl('documents.operation'), { DocumentIds: [this.document.id], DocumentTypeId: targetType.id })
									.then((result) => {
										this.$toast(this.$t('document.operations.change-state-success-single', { newState: targetType.name }), { type: 'success' })
										this.getOpeningDocument()
									})
									.catch(() => {
									}).finally(() => {
										wait.end()
									})
							},
						},
						{
							title: this.$t('dialog.cancel'),
							shortcut: $sc.find('cancel', 'dialog'),
							isCancel: true,
							handle: (button, page, e) => { },
						},
					],
				})
			},
			updateDocumentAggregation(params) {
				if (!params?.api) return

				let sumCredit = 0
				let sumDebit = 0

				params.api.forEachNode((node) => {
					if (node.data.rowState !== 'deleted' && node.data.currencyValues?.length) {
						sumCredit += Number(node.data.currencyValues[0].credit) || 0
						sumDebit += Number(node.data.currencyValues[0].debit) || 0
					}
				})

				this.documentAggregation = {
					credit: sumCredit,
					debit: sumDebit
				}
			},
			updateAttachmentsCount(documentId) {
				getAttachmentsCount('attachments.count', 'Document', documentId).then((res) => {
					this.attachmentButton.badgeNumber = res.data
				}).catch(() => {
					this.attachmentButton.badgeNumber = 0
				})
			},
			updateNoteButtonStatus(documentId) {
				getEntityNotes('Document', documentId).then((res) => {
					this.noteButton.badgeNumber = res?.text ? 1 : 0
				}).catch(() => {
					this.noteButton.badgeNumber = 0
				})
			},
			cellFocusChanged(event) {
				this.tableFocusedCell = event.column?.colDef?.field || null
				this.selectedFloatingCenterInfo = null

				this.selectedFloatingCenterInfoChanged()
			},
			async selectedFloatingCenterInfoChanged() {
				const cellFloatingCenter = this.selectDetailRow && this.selectDetailRow[0] && this.tableFocusedCell?.includes('center') ? this.selectDetailRow[0][this.tableFocusedCell] : null

				if (!cellFloatingCenter) {
					this.selectedFloatingCenterInfo = null
					return null
				}
				var floatingCenter = await this.floatingCenterGetById(cellFloatingCenter.id)
				var parents = []
				const setParentPath = async (center) => {
					let parent = {
						id: center.id,
						name: center.name,
						accountingCode: center.accountingCode,
						level: center.level,
					}
					if (center.parent && center.parent.id != emptyId)
						setParentPath(await this.floatingCenterGetById(center.parent.id))
					parents.push(parent)
				}
				await setParentPath(floatingCenter)
				floatingCenter.parents = parents

				this.selectedFloatingCenterInfo = floatingCenter
				return floatingCenter
			},
			selectedDetailRowChanged() {
				this.selectedFloatingCenterInfo = null
				this.selectedFloatingCenterInfoChanged()
			},
			subscribeKeys() {
				this.$keyHandler.Subscribe({
					name: 'load-document',
					keyCode: 13,
					el: this.$refs.docCode.$el,
					context: this,
					handler: function (sender, e) {
						e.preventDefault()
						this.onCodeEnterPressed = true
						this.loadIfPossible(this.document.code)
					},
				}),
					this.$keyHandler.Subscribe({
						name: 'account-change-log',
						shortcut: $sc.find('change-log'),
						el: this.$el,
						context: this,
						handler: function (sender, e) {
							this.getChangeLog()
						},
					}),
					this.$keyHandler.Subscribe({
						name: 'all-documents',
						keyCode: 32,
						el: this.$refs.docCode.$el,
						context: this,
						ctrlKey: true,
						handler: function (sender, e) {
							this.allDocuments()
						},
					})
			},
		},
	}
</script>
<style lang="less">
	@import (reference) '~/styles/site.config.less';

	.doc-header-layer {
		position: relative;
		z-index: 1;
	}

	.doc-top-bar {
		background-color: #ffffff;
		border-bottom: 1px dashed rgb(181 181 181);
		padding: 6px 11px;
		border-top-right-radius: 12px;
		border-top-left-radius: 12px;
		margin: -10px -10px 10px -10px;

		&__content {
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			justify-content: flex-start;
			gap: 7px;
		}
	}

	.doc-header-pill {
		display: inline-flex;
		align-items: center;
		gap: 5px;
		padding: 3px 10px;
		border-radius: 999px;
		font-size: 12.5px;
		font-weight: 500;
		line-height: 1.4;
		white-space: nowrap;

		&--source {
			background-color: fade(@primary, 12%);
			color: @primary-dark;
		}

		&--new {
			background-color: #E2F3E6;
			color: #2D6A3F;
		}

		&--status i {
			font-size: 13px;
		}

		&--lock {
			padding: 3px 10px;
			border-radius: 999px;
			background: #e74c3c;
			color: #ffffff;
			font-size: 12.5px;
			font-weight: 500;

			i {
				font-size: 12px;
			}
		}
	}

	.doc-details {
		padding: 0px;
		flex: 1;
		overflow: hidden;
	}

	.document-floating-table-cell-label {
		margin-left: 10px;
		float: right;
	}

	.nk-badges .nk-badge.state {
		color: #2c2e3e;
	}

	.sum-card {
		background-color: white;
		border-radius: 8px;
		flex-wrap: wrap;
		gap: 0px 12PX;

		.sum-section {
			flex: 1;

			.sum-title {
				color: rgb(151, 151, 151);
			}

			.sum-value {
				font-size: 13px;
				margin-right: 6px;

				&.debit {
					color: #EC4242;
				}

				&.credit {
					color: #28a745;
				}
			}
		}
	}

	.doc-details .ag-theme-quartz .ag-header .ag-header-row:not(.ag-floating-filter) .ag-header-cell-text {
		font-size: 12px;
		height: 26;
	}

	.col-6.col-md-7.col-sm-8 {
		min-height: 35px;
	}

</style>
